module.exports = __webpack_public_path__ + "img/4.a29bdd2f.webp";